import script from "./SingleTopKeyword.vue?vue&type=script&setup=true&lang=js"
export * from "./SingleTopKeyword.vue?vue&type=script&setup=true&lang=js"

import "./SingleTopKeyword.vue?vue&type=style&index=0&id=6b78dad2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6b78dad2"]])

export default __exports__